import { Component, OnInit, Input } from '@angular/core';
import { Booking } from '../../models/booking.model';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 'gaweb-confirmation-booking-detail',
  templateUrl: './confirmation-booking-detail.component.html'
})
export class ConfirmationBookingDetailComponent implements OnInit {
  @Input() booking: Booking;

  navigating = false;

  constructor(private localStorageService: LocalStorageService) { }

  ngOnInit() {
    this.localStorageService.resetOfflineBooking();
    this.localStorageService.resetManagedBooking();
  }

  getName() {
    return `${this.booking.Passengers[0].FirstName} ${this.booking.Passengers[0].Surname}`;
  }

  manageBooking = () => {
    this.navigating = true;
    window.location.href = `my-greyhound/booking-management/details?bookingGuid=${this.booking.BookingGuid}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/confirmation-booking-detail/confirmation-booking-detail.component.ts